"use client"

import { ScopeProvider } from "bunshi/react"
import { CollectionScope, type ScopeState } from "./scope"

interface Props {
  children: React.ReactNode
  state: ScopeState
}

export function CollectionScopeProvider({ children, state }: Props) {
  return (
    <ScopeProvider scope={CollectionScope} value={state}>
      {children}
    </ScopeProvider>
  )
}
